/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */

export default function () {
  const widgetName = 'suscribeWidget';
  const widgetOpts = suscribeWidgetOpts;

  function createButton(slide) {
    const cardWidget = $(`#${widgetName} .card-widget-item`);
    cardWidget.find('.card-widget-description').remove();
    
    const description = slide.items[0].Description;
    const link = slide.items[0].URL;
    const linkText = slide.items[0].DetailLinkText.substring(0, 12);

    const button = `
        <div class="card-widget-details ">
          <span class="card-widget-description">${description}</span>
          <a class="button" role="link" href="${link}" aria-label="Click here to contact us" >${linkText}</span>
        </div>`;

    $(cardWidget)
      .find('.card-content')
      .append(button);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (slide) {
      createButton(slide);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
